export function getPublicProviderRoute(id: string): string {
  return `/prestador/perfil/${id}`
}


